module.exports = __webpack_public_path__ + "static/media/download.be15dac9.svg";